export const UPDATE_SERVICEINFO = "UPDATE_SERVICEINFO";

export function updateServiceInfo(data){
    return { type: UPDATE_SERVICEINFO, payload: data};
}
